module.exports = __webpack_public_path__ + "img/modelo1.1356d34c.jpg";